export default __webpack_public_path__ + "static/crude-heater-8d13ee7f0aee3b7c6ee89e6472c75c72.png";